import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const FourthFifthNormalForm = () => (
  <QPhototModuleSubtopic
    title="Multi-valued dependency and Fourth Normal form - Join dependency and Fifth Normal form"
    videos={[
      "https://www.youtube.com/embed/OTCuykFHBeA",
      "https://www.youtube.com/embed/mbj3HSK28Kk",
      "https://www.youtube.com/embed/dgYJmclPsEQ",
      "https://www.youtube.com/embed/6L-AK_Ib17k"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "1) A relation R has attributes A, B, C, D, E, and satisfies the following FDs: A->BC, B->D, CD->E, E->A\na) Show that (A, B, C) and (A, D, E) are a lossless decomposition of R.\nb) Show that (A, B, C) and (C, D, E) are not a lossless decomposition of R.\nc) Show that (A, B, C) and (A, D, E) are a lossless decomposition of R.\nd) Show that (A, B, C) and (C, D, E) are not a lossless decomposition of R.\ne) Show that (A, B, C) and (A, D, E) are not a dependency preserving decomposition of R.",
        image:"/dbms_21.png"
      },
      {
        text: "2) Identify the MVDs present in the table and normalize it to 4NF."
      },
      {
        text: "3) Suppose we have a database for an investment firm, consisting of the following attributes:\nB - Broker,\nO - Office of a broker\nI - Investor\nS - Stock\nQ - Quantity of stock owned by an investor\nD - Dividend paid by a stock.\nHence, the overall schema is R = (B, O, I, S, Q, D).\nAssume that the following functional dependencies are required to hold on this\ndatabase.\nFD = {I -> B, IS-> Q, B -> O, S -> D}\ni) List all the candidate keys for R.\nii) List the prime and non-prime attributes\niii) Classify to which normal form the present form of Relation R belongs to and\njustify the answer.\niv) Identify the FD's which violates the property of a particular normal form and\nperform lossless-join decomposition of R into subsequent normal forms\n(continue up to BCNF)."
      }
    ]}
    exampleVideos={[]}
  />
);

export default FourthFifthNormalForm;
